import { ApiProject, ApiSimpleComponent } from "@incendium/api";
import { personalisationService } from "Apis";
import { useProjectSharedState } from "Hooks/useSharedState";

const fetch = async (selectedProject: ApiProject | null) => {
    if (selectedProject) {
        const res =
            await personalisationService.personalisationServiceListLanderBlockComponents(
                {
                    projectId: selectedProject.id as number,
                }
            );
        return res.components || [];
    }
    return [];
};
export const useLanderBlocks = () => {
    const { state, setState, loading, refetch, fetched } = useProjectSharedState<
        ApiSimpleComponent[]
    >("landerBlocks", [], fetch);

    return {
        blocks: state,
        setBlocks: setState,
        loading,
        refetch,
        fetched,
    };
};
